import { Component, EventEmitter, OnInit, Output, QueryList } from '@angular/core';
import moment from 'moment';
import { AppService } from 'src/app/core/services/app.service';

@Component({
	selector: 'app-check-search',
	templateUrl: './check-search.component.html',
	styleUrls: ['../../../modules/commandCenter/commandcenter.scss'],
})
export class CheckSearchComponent implements OnInit {
	@Output() checkQueryParamsChange = new EventEmitter<string>();

	dateType: string = 'single';
	searchCriteria = {
		account: undefined,
		businessDate: undefined,
		checkKey: undefined,
		checkNumber: undefined,
		dueDateTime: undefined,
		email: undefined,
		end: undefined,
		externalId: undefined,
		futureOrder: undefined,
		source: undefined,
		start: undefined,
		status: undefined,
		timeOpened: undefined,
	};

	constructor(public app: AppService) {}

	ngOnInit(): void {}

	onReturn() {
		let queryParams = undefined;

		Object.keys(this.searchCriteria).forEach((key) => {
			if (this.searchCriteria[key]) {
				if (key === 'businessDate' || key === 'end' || key === 'start' || key === 'dueDateTime') {
					this.searchCriteria[key] = moment(this.searchCriteria[key]).format('YYYY-MM-DD');
				}
				if (queryParams) {
					queryParams += `&${key}=${this.searchCriteria[key]}`;
				} else {
					queryParams = `${key}=${this.searchCriteria[key]}`;
				}
			}
		});
		console.log(queryParams);

		this.checkQueryParamsChange.emit(queryParams);
	}
}
